module.exports = __webpack_public_path__ + "img/img-a88db8e5.c180d5cd.png";